import React, { Suspense } from "react";
import { Route, Switch } from "react-router-dom";

import AppContext from "src/contexts/AppContext";

import Loader from "src/components/Layout/Loader";
import Layout from "src/components/Layout/Layout";
import Home from "src/pages/Home";
import Help from "src/pages/Help";
import HelpID from "src/components/Help/id";
import Video from "src/pages/Video";
import VideoMobile from "src/pages/Emcmobile";
import Password from "src/pages/Pass";
import Links from "./pages/links";

const Router = () => {
  return (
    <Suspense fallback={<Loader />}>
      <AppContext>
        <Switch>
          <Route exact path="/links" component={Links} />

          <Layout>
            <Route exact path="/" component={Home} />
            <Route exact path="/help" component={Help} />
            <Route exact path="/help/:id" component={HelpID} />
            <Route exact path="/video" component={Video} />
            <Route exact path="/emcmobile" component={VideoMobile} />
            <Route exact path="/pass" component={Password} />
          </Layout>
        </Switch>
      </AppContext>
    </Suspense>
  );
};

export default React.memo(Router);
